<div *ngFor="let item of items">
  <app-content-block [item]="item" [isWide]="true"></app-content-block>
</div>
